export default "__VITE_ASSET__oDTl8LRyXKJh1JPUfpzr3w__"